import React, { useEffect, useState } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { isEmpty } from 'lodash';
import { Card, Col, FormGroup, Row } from 'react-bootstrap';
import { ElementTemplate } from '../../../Library/P.O.Template/TemplateComponent';

function CustomPreviewTable({ element, fromForm }) {
  const [customData, setCustomData] = useState(null);

  useEffect(() => {
    if (!isEmpty(element)) {
      setCustomData({ ...element });
    }
  }, [element]);

  return (
    <DndProvider backend={HTML5Backend}>
      <Card className="listing-card">
        <Card.Header className={fromForm ? 'px-2 py-2 bgcolor-dark d-flex' : 'px-2 py-2 bgcolor-dark'}>
          <strong>{customData?.label}</strong>
        </Card.Header>

        <Card.Body className="py-4">
          <Row className="span_font_size">
            {customData?.columns?.map((column, index) => {
              return (
                <Col lg={6} key={index}>
                  {column?.map((col) => {
                    return (
                      <FormGroup key={col?.key}>
                        <ElementTemplate
                          {...col}
                          keys={col?.key}
                          error={col?.hasError}
                          requiredField={col?.required}
                          disable
                          value={col?.value}
                          options={col?.options}
                          placeHolder={col?.placeholder ? `${col?.placeholder}` : `${col?.label}`}
                          fromForm={fromForm}
                        />
                      </FormGroup>
                    );
                  })}
                </Col>
              );
            })}
          </Row>
        </Card.Body>
      </Card>
    </DndProvider>
  );
}

export default CustomPreviewTable;
